import(/* webpackMode: "eager", webpackExports: ["Footer7"] */ "/opt/build/repo/components/ui/Standards/footer-7.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar1"] */ "/opt/build/repo/components/ui/Standards/navbar.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
